import { ContactRequestService } from './../../services/contact-request.service';
import { MiniatureListComponent } from './miniature-list/miniature-list.component';
import { ContactRequest } from './../../model/contact/contact-request';
import { Component, OnInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FormGroupDirective } from "@angular/forms/forms";
import { FormGroup } from "@angular/forms/src/model";
import { NgForm } from "@angular/forms/src/directives";
import { GlobalFunctions } from '../libs/global-functions';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/toPromise';
import { MdSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { modelGroupProvider } from '@angular/forms/src/directives/ng_model_group';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.less'],
  providers: [ContactRequestService],
})
export class ContactComponent implements OnInit {

  EMAIL_REGEX=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  readonly infoMaxLength=3000;
  model = new ContactRequest('', '', '', '', '', new Object());
  submitted = false;
  @ViewChildren("input") inputs: QueryList<any>



  constructor(private contactRequestService: ContactRequestService, public snackBar: MdSnackBar, private router: Router) { }

  getVoucherIndices() : Array<number> {
    var arr = [];
    var i = 0;
    this.model.vouchers.forEach((v : string) => {
      arr.push(i);
      i++;
    })
    arr.push(i);
    return arr;
  }

  onSubmit(contactForm: NgForm) {
    if (this.submitted || contactForm.invalid) {
        if (contactForm.form.invalid) {
          Object.keys(contactForm.form.controls).some(key => {
            if (contactForm.form.get(key).invalid) {
              console.log(key);
              GlobalFunctions.scrollToElement('#'+key, 500);
              return true;
            }
            return false;
          });
      }
      return;
    }
    this.submitted = true;
    let call:Observable<Response> = this.contactRequestService.doContactRequest(this.model);
    call.toPromise().then((value: Response) => {
      if(value.ok){
        this.submitted = false;
        this.clearFields();
        contactForm.resetForm();
        setTimeout(() => {
          this.snackBar.open('Vielen Dank für deine Anfrage!', undefined, {
          duration: 5000,
          })
        }, 0);
        setTimeout(() => {
          this.router.navigateByUrl('/home');
        }, 10); 
      }
    }).catch(() => {
      this.submitted = false;
      setTimeout(() => {
          this.snackBar.open('Es ist ein Fehler aufgetreten, bitte versuche es später erneut!', undefined, {
            duration: 5000,
          });
      }, 0);
    });
  }

  private clearFields(){
    this.model.miniatures = [];
    this.model = new ContactRequest('', '', '', '', '', new Object());
    this.inputs.forEach((input: ElementRef) => {
      input.nativeElement.value = '';
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/contact/contact.component.ts